import { useEffect, useState } from "react";
import { notesApi } from "../api/client.js";

/* Whether this deployment can send mail. Asked once and cached for the
   session: with no SMTP host configured, the Notify and Send-a-note
   controls are hidden rather than offered and then failing. */
let cached = null;

export function useMailEnabled() {
  const [enabled, setEnabled] = useState(cached ?? false);

  useEffect(() => {
    if (cached !== null) return;
    let live = true;
    notesApi
      .config()
      .then(({ enabled: on }) => {
        cached = Boolean(on);
        if (live) setEnabled(cached);
      })
      .catch(() => {
        cached = false;
      });
    return () => {
      live = false;
    };
  }, []);

  return enabled;
}
